import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UploadService } from '../../Services/upload.service';
import { DocumentService } from '../../Services/document.service';
import { MemberService } from '../../Services/member.service';
import { Response } from '@angular/http';
import Swal from 'sweetalert2';
import { saveAs } from 'file-saver';
import { forEach } from 'lodash';
import { SubscriptionService } from '../../Services/subscription.service';
import { AuthService } from '../../Services/auth.service';
import { VolunteerSubsriptionService } from '../../Services/volunteerSubscription.service';

@Component({
  selector: 'app-document-admin-form',
  template: require('./document-admin-form.component.html'),
  styles: [require('./document-admin-form.component.css')]
})
export class DocumentAdminFormComponent implements OnInit {
  @ViewChild("fileInput") fileInput: ElementRef;
  
  document: any = {
    "id":-1,
    "filename": "",
    "members": [],
    "name": "",
    "availableForAll": false
  }

  action : string = "Nieuw"
  documents:any[] = [];
  members:any[] = [];
  fileInputDisabled: boolean = false;
  nameSearchString: string = '';
  searched_members: any[] = [];
  selectedMembersCount = 0;
  selected_members:any[] = [];
  showOnlySelected: boolean = false;
  subscriptionList: any[] = [];
  volunteerEventList: any[] = [];
  documentForAllMembers: boolean = false;
  currentSubscriptionId: number = -1;
  currentVolunteerEventId: number = -1;

  uploadFile:any;
  // documentName: string = "";


  constructor(private auth: AuthService,
              private uploadService: UploadService,
              private documentService: DocumentService,
              private memberService: MemberService,
              private subscriptionService: SubscriptionService,
              private volunteerSubsriptionService: VolunteerSubsriptionService) { }

  ngOnInit() {
    // this.getAllDocuments();
    // this.loadAllMembers();
  }

  ngAfterViewInit(){
    this.getAllDocuments();    
    this.loadAllMembers();
    this.getAllSubscriptions()
    this.getAllVolunteerEvents()
  }

  getAllDocuments(){
    // console.log('getAllDocuments');
    
    this.documentService.getAllDocuments().subscribe( res => {
      this.documents = res;
      // console.log(this.documents);
    });
  }

  refresh(){
    this.getAllDocuments();
  }

  loadAllMembers() {
    // console.log('loadAllMembers');
    
    // console.log("loading all members");
    this.memberService.getMembers().subscribe(x => {
      this.members = x;
      // console.log(this.members);
      this.selectedMembersCount =  this.selected_members.length;
      this.searched_members = this.members
    });
  }


  getAllSubscriptions(){
     this.subscriptionService.getAllSubscriptions().subscribe((res: any) => {
       this.subscriptionList = res
     })
  }

  getAllVolunteerEvents(){
     this.volunteerSubsriptionService.getAllVolunteerActivities().subscribe( (res:any)=>{
      if (res.status == 200){
        this.volunteerEventList = res.value
      }
        console.log(this.volunteerEventList);
        
    } )
  }
  



  getAllSubscribedMembers(clear:boolean){
     this.subscriptionService.GetCurrentMembersForSubscription(this.currentSubscriptionId).subscribe( (res:any) =>{
      if (clear){
        this.selected_members = []
      }
      
      res.forEach( (item:any) => {
        var i = this.selected_members.findIndex( (it:number) => it == item.member.id)
        if (i ==-1 ){
          this.selected_members.push(item.member.id)
        }
      });
      this.selectedMembersCount =  this.selected_members.length
    
     })    
  }

  getAllVolunteerMembers(clear:boolean){
    this.volunteerSubsriptionService.getAllMemberVolunteerSubscriptionsForActivity(this.currentVolunteerEventId).subscribe( (res:any)=>{
        if (res.status == 200){
          var data = res.value
          if (clear){
            this.selected_members =[]
          }

          data.forEach( (item:any) => {
            if (item.isMember){
              var i = this.selected_members.findIndex( (it:number)=> it == item.member.id )
              if (i ==  -1){
                this.selected_members.push(item.member.id)
              }
            }
            this.selectedMembersCount = this.selected_members.length
          });

        }

        

      
    } )
  }


  uploadDocument() {
    var nativeElement: HTMLInputElement = this.fileInput.nativeElement;
    if (nativeElement != null) {
      var files = nativeElement.files;
      if (files != null) {
        var file = files[0];
        // console.log("Upload file: ")
        // console.log(file.name);
        this.uploadService.uploadFileToDocument(file).subscribe(x => {
          // console.log(x);
          this.uploadFile = x;
        })
      }
    }
  }

  showRow(id: any){
    if (this.showOnlySelected && this.isSelected(id)) return true;
    else if (!this.showOnlySelected) return true;
  }

  isSelected(id: any){
    if (this.selected_members.find( x => x == id)){
      return true;
    }
    else{
      return false
    }
  }

  checkboxClicked(id: any) {
    // console.log("checkbox clicked:")
    // console.log(id);
    if (this.selected_members.find( x => x == id)){
      const index = this.selected_members.indexOf(id, 0);
      if (index > -1) {
        this.selected_members.splice(index, 1);
      }

    }else{
      this.selected_members.push(id);
    }
    // console.log(this.selected_members);
    this.selectedMembersCount =  this.selected_members.length
  }


  selectAllMembers(event: any){
    if (event.target.checked){
      this.members.forEach( e => this.selected_members.push(e.id));
      this.documentForAllMembers = true;
      this.selectedMembersCount = this.selected_members.length;
    }
    else{
      this.selected_members= [];
      this.documentForAllMembers = false;
      this.selectedMembersCount = 0;
    }
  }
  
  clearSearch(){
    this.nameSearchString = '';
    this.searchName();
  }

  searchName(){
    if (this.nameSearchString.length > 0){
      // console.log(this.nameSearchString);

      let f = this.members.filter( (a:any) => a.firstName.toLowerCase().indexOf(this.nameSearchString.toLowerCase()) > -1) ;
      let l = this.members.filter( (a:any) => a.lastName.toLowerCase().indexOf(this.nameSearchString.toLowerCase()) > -1) ;

      this.searched_members = f
      this.searched_members = this.searched_members.concat(l)
      
    }else{
      // this.searched_members = this.groups
      this.searched_members = this.members;
    }


  }

  addDocument(){
    // console.log('*************************************************');
    
    // console.log('document to save: '+ JSON.stringify(this.document));
    
    var members = [];
    if (this.documentForAllMembers){
      members.push(-1);
    }
    else{
      members = this.selected_members;
    }

    this.document.members = members;
    this.document.availableForAll = this.documentForAllMembers;

    if (this.document.id == -1){
      this.document.filename = this.uploadFile.filename;
      this.documentService.addNewDocument(this.document).subscribe( res => {
        // console.log(res);
        this.refresh();
      });
    }else{
      this.documentService.updateDocument(this.document).subscribe( res => {
        // console.log(res);
        this.refresh();
      })
    }

    
   
    // this.document.name = this.documentName;
    
    // var document = {
    //   "filename": this.uploadFile.filename,
    //   "members":members,
    //   "name": this.documentName,
    //   "availableForAll": this.documentForAllMembers
    // }

    // console.log(this.document);
    
    

  }

  loadMembersForDocuments(id: number){
    var doc = this.documents.find( d => d.id == id);
    this.document = doc;
    this.selected_members = [];

    if (doc.availableForAll){
      this.members.forEach( (m:any) => this.selected_members.push(m.id));
    }else{
      doc.documentMembers.forEach((dm:any) => this.selected_members.push(dm.memberId));
    }

    this.selectedMembersCount = this.selected_members.length
    this.fileInputDisabled = true;
    this.action = "Bewerken"

    // console.log(this.selected_members);  
    // console.log("---------------------------");
    // console.log("current doc: "+ JSON.stringify(this.document)) ;
    
    

  }

  deleteDocument(id: number){
    Swal.fire({
        title: 'Ben je zeker?',
        text: "Ben je zeker dat je dit document wil verwijderen?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Jep',
        cancelButtonText: 'Nope'
      }).then((result) => {
        if (result.value) {
          this.documentService.deleteDocument(id).subscribe( res => {
            // console.log(res);
            this.refresh();
          })
        }
      });   
  }

  clearDocument(){
    this.document = {
      "id":-1,
      "filename": "",
      "members": [],
      "name": "",
      "availableForAll": false
    }
    this.fileInputDisabled = false;
    this.action = "Nieuw";
  }

  downloadDocument(id:number){
    // console.log(id);
    this.documentService.downloadDocument(id).subscribe((res: Response) =>{
      if (res.headers){
        var header = "";
        header = res.headers.get('content-disposition') || "";
        var startIndex = header.indexOf("filename=") + 9; // Adjust '+ 9' if filename is not the right one.
        var endIndex = header.indexOf(";", startIndex);
        var filename = header.substring(startIndex, endIndex);
        // console.log("filename: " + filename)
        saveAs(res.blob(), filename);
      }
    });
    
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/document-admin-form/document-admin-form.component.ts